// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yg9V","newExpiryDate":"styles_newExpiryDate__2LtHr","footer":"styles_footer__O35wl"};